import styles from "src/css/modules/Blogs.module.scss"
import { BlogItem } from "./BlogItem"

export function AllArticles({ blogs = [], search, mobile }: { blogs: any[]; search?: boolean; mobile?: boolean }) {
    return (
        <div className={styles.allArticles}>
            <div className={styles.articleHead}>
                {search ? "Search result" : "All articles"}
                <span className={styles.line} />
            </div>
            <div className={styles.overBlogItems}>
                {blogs.map((i, index) => {
                    return <BlogItem key={i.slug} {...i} mobile={mobile} index={index % 3} />
                })}
            </div>
        </div>
    )
}
